import React from "react";
import { Modal, GeneralInput, GeneralButton } from "../../components";
import { FormProvider, useForm } from "react-hook-form";
import useAddPrescription from "../../api/Prescription/useAddPrescription";
import { useToast } from "../../Services/ToastContext";
import { cleanFormData } from "./utils";
import { useQueryClient } from "@tanstack/react-query";
import { EndPoints } from "../../Constants/endpoints";
import { useTranslation } from "react-i18next";

interface IAddExistPrescriptionToTemplates {
  isOpen: boolean;
  onClose: () => void;
  templateData?: any;
}

const AddExistPrescriptionToTemplates: React.FC<
  IAddExistPrescriptionToTemplates
> = ({ isOpen, onClose, templateData }) => {
  const addPrescriptionMutation = useAddPrescription();
  const { showToast } = useToast();

  const { t } = useTranslation();
  const methods = useForm({
    defaultValues: { Case: templateData?.Case },
  });
  const { handleSubmit, reset } = methods;
  const queryClient = useQueryClient();

  const onSubmit = (values: any) => {
    const cleanedData = cleanFormData({
      Drugs: templateData?.Drugs,
      Case: values?.Case,
    });

    addPrescriptionMutation.mutate(cleanedData, {
      onSuccess: () => {
        showToast(t("prescription_added_successfully"), "success");
        reset();
        onClose();
        queryClient.refetchQueries({
          queryKey: [EndPoints.GetPrescriptions],
          exact: false,
        });
      },
      onError: (error) => {
        showToast(
          error.message ? error.message : t("error_adding_prescription"),
          "error",
        );
      },
    });
  };

  return (
    <Modal header={t("save_as_template")} onClose={onClose} isOpen={isOpen}>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <GeneralInput
            name={"Case"}
            label={t("template_name")}
            placeholder={t("template_name")}
          />
          <div className={`mt-6 flex justify-end gap-2`}>
            <GeneralButton
              onClick={onClose}
              className={`text-body-text !mb-0 !h-10 w-full rounded-lg md:w-fit`}
              color="lite"
              fontColor="body-text"
              title={t("cancel")}
            />
            <GeneralButton
              className={`!mb-0 !h-10 w-full rounded-lg md:w-[208px]`}
              title={t("add_to_templates")}
              type={"submit"}
            />
          </div>
        </form>
      </FormProvider>
    </Modal>
  );
};

export default AddExistPrescriptionToTemplates;
